<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper :items="data" :fields="fields" hover :striped="true" :border="true" small fixed
          caption="Lista de Metodos de Pago" icon="fas fa-coins" btn_name="Metodo de Pago" @mtdBack="mtdBack"
          @show_modal="mtd_open_modal" @action_edit="mtd_show" @action_delete="mtd_delete" :size="'md'"
          :button_new="true" :actions="true" :withActions="'2%'" :buttonEdit="true" :buttonDelete="true" />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="modal.title" :button="cp_button"
      :show.sync="modal.modal_form" @mtd_action="mtd_action" :color="'info'" :centered="true">
      <CRow v-if="$store.getters.get_all_user.id != 1">
        <CCol sm="12">
          <cSelectForm label="Método de Pago" placeholder="Método de Pago" :options="data_methodPayment"
            :value.sync="method_payment.name" size="sm" />
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue :key="componentKey" @changeSwitch="changeSwitch" class="mx-1 pl-2 pt-2"
            :checked="method_payment.state == 1 ? true : false" color="success" variant="opposite" shape="pill"
            v-bind="labelIcon" />
        </CCol>
      </CRow>

      <CRow v-else>
        <CCol sm="12">
          <CInput label="Nombre" placeholder="Digite nombre" v-model="method_payment.name" />
        </CCol>

        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue :key="componentKey" @changeSwitch="changeSwitch" class="mx-1 pl-2 pt-2"
            :checked="method_payment.state == 1 ? true : false" color="success" variant="opposite" shape="pill"
            v-bind="labelIcon" />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete :backdrop="true" :closeOnBackdrop="true" :size="'md'" :title="'Borrar Metodo de Pago'"
      :show.sync="modal_delete.boo" @mtd_commit="mtd_commit" :centered="true" :item="modal_delete.item" />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "status", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../../shared/datatable/Table.vue";
import CModalForm from "../../shared/modals/cModalForm.vue";
import cModalDelete from "../../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import CSwitchVue from "../../shared/switch/CSwitch.vue";
import cSelectForm from "../../shared/inputs/cSelect.vue";

export default {
  components: {
    CTableWrapper,
    CModalForm,
    cModalDelete,
    CSwitchVue,
    cSelectForm,
  },
  data() {
    return {
      prefix: "methods_payments",
      fields,
      data_methodPayment: [],
      data: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      method_payment: {
        id: "",
        user_id: this.$store.getters.get_all_user.id,
        company_id: this.$store.getters.get_all_user.id == 1 ? "" : this.$store.getters.get_company.id ? this.$store.getters.get_company.id : 0,
        name: "",
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      // dataStore: [],
    };
  },
  computed: {
    cpStatus: function () {
      if (this.method_payment.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (this.method_payment.name != "") return false;
      return true;
    },
  },
  created() {
    this.mtd_getdata();
    if (this.$store.getters.get_all_user.id != 1) {
      this.indexMethodPayment();
    }
  },
  methods: {
    ...mapActions(["get", "post"]),
    indexMethodPayment: function () {
      this.get({
        url: this.$store.getters.get__url + "/" +
          this.prefix + "/byMethodPayment",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.data.forEach((element) => {
            this.data_methodPayment.push({
              label: element.name,
              value: element.Id,
            });
          });
        })
        .catch((errors) => { });
    },
    mtd_getdata: function () {
      let url
      this.get({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/index/" + this.$store.getters.get_all_user.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.data;
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          });
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Metodo de Pago")
        : (this.modal.title = "Editar Metodo de Pago");
      action == "store"
        ? (this.method_payment = {
          id: "",
          user_id: this.$store.getters.get_all_user.id,
          company_id: this.$store.getters.get_all_user.id == 1 ? "" : this.$store.getters.get_company.id ? this.$store.getters.get_company.id : 0,
          name: "",
          state: "",
        })
        : (this.method_payment = { ...this.method_payment });
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.method_payment,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({
              title: "Metodo de Pago ya resgistrado",
              icon: "warning",
            });
          } else {
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              let updatedMethodPayment = response.data.data;
              let index = this.data.findIndex(
                (method_payment) =>
                  method_payment.id === updatedMethodPayment.id
              );
              if (index !== -1) {
                this.$set(this.data, index, updatedMethodPayment);
              }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };
            this.method_payment = {
              id: "",
              user_id: this.$store.getters.get_all_user.id,
              company_id: this.$store.getters.get_all_user.id == 1 ? "" : this.$store.getters.get_company.id ? this.$store.getters.get_company.id : 0,
              name: "",
              state: 0,
            };

            Swal.fire({
              title: message,
              icon: color,
            });
          }
        })
        .catch((errors) => {
          Swal.fire({
            title: errors,
            icon: "danger",
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.method_payment = response;
          this.method_payment.user_id = this.$store.getters.get_all_user.id;
          this.data_methodPayment.forEach((arr) => {
            if (arr.label == response.name) {
              this.method_payment.name = arr.value;
            }
          })
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => { });
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.Id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };
          Swal.fire({
            title: "ELIMINADO CORRECTAMENTE",
            icon: "success",
          });
        })
        .catch((errors) => { });
    },
    changeSwitch: function (payload) {
      this.method_payment.state = payload == true ? 1 : 0;
    },
  },
  destroyed() {
    // console.log(this.dataStore);
    // this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
